import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  useTheme,
  styled,
  Grid,
  Card,
  CardContent,
  Avatar
} from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

// Styled components
const GradientBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  position: 'relative',
  overflow: 'hidden',
  color: 'white',
}));

const GlowEffect = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '500px',
  height: '500px',
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)',
  zIndex: 0,
}));

const TestimonialCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
  },
}));

const CTASection: React.FC = () => {
  const theme = useTheme();

  const testimonials = [
    {
      name: 'Алексей Морозов',
      role: 'NFT Художник',
      quote: 'С ArtNFT я наконец-то смог увидеть полную картину того, как продаются мои работы. Аналитика помогла мне увеличить продажи на 40%.',
      avatar: 'https://source.unsplash.com/random/100x100/?portrait,man,1'
    },
    {
      name: 'Екатерина Белова',
      role: 'Инфлюенсер',
      quote: 'Удобный интерфейс и точные данные в реальном времени. ArtNFT стал незаменимым инструментом для мониторинга моих коллекций.',
      avatar: 'https://source.unsplash.com/random/100x100/?portrait,woman,1'
    },
  ];

  return (
    <GradientBox>
      {/* Decorative elements */}
      <GlowEffect sx={{ top: '-250px', right: '-150px' }} />
      <GlowEffect sx={{ bottom: '-200px', left: '-100px' }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Box sx={{ position: 'relative' }}>
              <Typography 
                variant="h2" 
                fontWeight="700" 
                sx={{ mb: 3 }}
              >
                Раскройте потенциал ваших NFT-коллекций
              </Typography>
              <Typography 
                variant="h5" 
                sx={{ 
                  mb: 5, 
                  fontWeight: 400, 
                  opacity: 0.9,
                  lineHeight: 1.6
                }}
              >
                Присоединяйтесь к тысячам цифровых творцов, которые уже используют нашу платформу для повышения эффективности их NFT-стратегии.
              </Typography>
              <Button 
                variant="contained" 
                color="secondary" 
                size="large"
                endIcon={<KeyboardArrowRightIcon />}
                sx={{ 
                  py: 1.5, 
                  px: 4, 
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  backgroundColor: 'white',
                  color: theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    boxShadow: '0 6px 20px rgba(255, 255, 255, 0.3)'
                  }
                }}
              >
                Начать сейчас
              </Button>
            </Box>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box>
              <Typography 
                variant="h4" 
                fontWeight="600" 
                sx={{ mb: 3, display: 'flex', alignItems: 'center' }}
              >
                <ThumbUpIcon sx={{ mr: 1 }} /> Отзывы пользователей
              </Typography>
              
              <Grid container spacing={3}>
                {testimonials.map((testimonial, index) => (
                  <Grid item xs={12} key={index}>
                    <TestimonialCard>
                      <CardContent sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Avatar
                            src={testimonial.avatar}
                            sx={{ width: 56, height: 56, mr: 2, border: '2px solid white' }}
                          />
                          <Box>
                            <Typography variant="h6" fontWeight="600">
                              {testimonial.name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {testimonial.role}
                            </Typography>
                          </Box>
                        </Box>
                        <Typography variant="body1" sx={{ color: 'text.primary' }}>
                          "{testimonial.quote}"
                        </Typography>
                      </CardContent>
                    </TestimonialCard>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </GradientBox>
  );
};

export default CTASection; 